module.exports = __webpack_public_path__ + "img/bi.73c70fbf.png";